export const getNotificationPageInfo = (response, fallbackPage = 0) => {
    const metadata = response?.page ?? response;
    const number = Number(metadata?.number);
    const totalPages = Number(metadata?.totalPages);
    const page = Number.isInteger(number) ? number : fallbackPage;
    const hasMore = response?.last === false
        || (Number.isFinite(totalPages) && page + 1 < totalPages);

    return { page, hasMore };
};

export const loadNotificationsThroughUnread = async ({
    fetchPage,
    unreadCount = 0,
    pageSize = 20,
}) => {
    const targetUnread = Math.max(0, Number(unreadCount) || 0);
    const items = [];
    const seenIds = new Set();
    let requestedPage = 0;
    let loadedPage = 0;
    let hasMore = false;

    do {
        const response = await fetchPage(requestedPage, pageSize);
        const content = Array.isArray(response?.content) ? response.content : [];
        content.forEach(item => {
            if (item?.id == null || !seenIds.has(item.id)) {
                items.push(item);
                if (item?.id != null) seenIds.add(item.id);
            }
        });

        const pageInfo = getNotificationPageInfo(response, requestedPage);
        loadedPage = pageInfo.page;
        hasMore = pageInfo.hasMore;
        const loadedUnread = items.filter(item => !item?.readAt).length;
        if (!hasMore || loadedUnread >= targetUnread) break;

        requestedPage = loadedPage + 1;
    } while (true);

    return { items, page: loadedPage, hasMore };
};
